/* KaradağMarket theme JS — km */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  document.body.classList.add('km-anim-ready');
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('km-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  $$('.km-reveal').forEach(function (el) { io.observe(el); });

  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target, target = parseFloat(el.dataset.count || '0'),
          dec = parseInt(el.dataset.decimals || '0', 10), suf = el.dataset.suffix || '';
      var t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / 1400, 1), v = target * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toLocaleString('tr-TR', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + suf;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      cio.unobserve(el);
    });
  }, { threshold: 0.4 });
  $$('[data-count]').forEach(function (el) { cio.observe(el); });

  document.addEventListener('click', function (ev) {
    var q = ev.target.closest('.km-faq-q');
    if (!q) return;
    var item = q.closest('.km-faq-item'), open = item.classList.toggle('km-open');
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    var a = item.querySelector('.km-faq-a');
    if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
  });

  $$('.km-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var scope = btn.closest('[data-km-tabs]') || document;
      $$('.km-tab-btn', scope).forEach(function (b) { b.classList.remove('km-active'); });
      $$('.km-tab-panel', scope).forEach(function (p) { p.classList.remove('km-active'); });
      btn.classList.add('km-active');
      var p = scope.querySelector('.km-tab-panel[data-content="' + btn.dataset.tab + '"]');
      if (p) p.classList.add('km-active');
    });
  });

  $$('[data-km-carousel]').forEach(function (root) {
    var slides = root.querySelector('.km-testi-slides');
    if (!slides || !slides.children.length) return;
    var n = slides.children.length, i = 0, dotsWrap = root.querySelector('.km-testi-dots');
    function go(k) {
      i = (k + n) % n;
      slides.style.transform = 'translateX(-' + i * 100 + '%)';
      if (dotsWrap) $$('.km-testi-dot', dotsWrap).forEach(function (d, j) { d.classList.toggle('km-active', j === i); });
    }
    if (dotsWrap) {
      for (var k = 0; k < n; k++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'km-testi-dot' + (k === 0 ? ' km-active' : '');
        d.dataset.i = k; d.setAttribute('aria-label', 'Yorum ' + (k + 1));
        d.addEventListener('click', function (e) { go(parseInt(e.currentTarget.dataset.i, 10)); });
        dotsWrap.appendChild(d);
      }
    }
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    setInterval(function () { go(i + 1); }, 6500);
  });

  var hdr = $('#km-hdr');
  if (hdr) window.addEventListener('scroll', function () { hdr.classList.toggle('km-scrolled', window.scrollY > 8); }, { passive: true });
  var mm = $('#km-mobile-menu'), ov = $('#km-overlay'), cdw = $('#km-cart-drawer');
  function closeAll() {
    if (mm) mm.classList.remove('km-open');
    if (cdw) cdw.classList.remove('km-open');
    if (ov) ov.classList.remove('km-open');
  }
  var hb = $('#km-hamburger');
  if (hb) hb.addEventListener('click', function () { mm.classList.add('km-open'); if (ov) ov.classList.add('km-open'); });
  var mc = $('#km-mm-close'); if (mc) mc.addEventListener('click', closeAll);
  if (ov) ov.addEventListener('click', closeAll);
  var dd = $('#km-cat-dropdown'), db = $('#km-cat-drop-btn');
  if (db) {
    db.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dd.classList.toggle('km-open');
      db.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!dd.contains(e.target)) { dd.classList.remove('km-open'); db.setAttribute('aria-expanded', 'false'); }
    });
  }

  function setCartCount(n) {
    $$('.km-cart-badge').forEach(function (b) { b.textContent = n; b.classList.toggle('km-show', n > 0); });
    var c = $('#km-cd-count'); if (c) c.textContent = n;
  }
  function fmtMoney(cents, cur) {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cur || 'TRY' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  var protVar = cdw ? parseInt(cdw.dataset.protectionVariant || '0', 10) : 0;
  var freeshipThr = cdw ? parseFloat(cdw.dataset.freeship || '150') : 150;
  var reserveMin = cdw ? parseInt(cdw.dataset.reserveMin || '5', 10) : 5;
  var reserveTimer = null;

  function startReserve() {
    var bar = $('#km-cd-reserve'), t = $('#km-cd-timer');
    if (!bar || !t) return;
    var key = 'kmReserveEnd';
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    var now = Date.now();
    if (!end || end < now) { end = now + reserveMin * 60000; sessionStorage.setItem(key, String(end)); }
    bar.style.display = '';
    if (reserveTimer) clearInterval(reserveTimer);
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      if (s <= 0) { clearInterval(reserveTimer); }
    }
    tick();
    reserveTimer = setInterval(tick, 1000);
  }

  function renderDrawer(c) {
    if (!cdw) return;
    var visibleItems = c.items.filter(function (it) { return it.variant_id !== protVar; });
    var visCount = visibleItems.reduce(function (a, it) { return a + it.quantity; }, 0);
    setCartCount(visCount);
    var body = $('#km-cd-body'), sub = $('#km-cd-subtotal'), total = $('#km-cd-total'),
        co = $('#km-cd-checkout'), fsp = $('#km-cd-freeship'), pchk = $('#km-cd-protect-check');
    var subCents = visibleItems.reduce(function (a, it) { return a + it.original_line_price; }, 0);
    if (sub) sub.textContent = fmtMoney(subCents, c.currency);
    if (total) total.textContent = fmtMoney(c.total_price, c.currency);
    var disc = c.total_discount || 0;
    var discRow = document.getElementById('km-cd-discount-row');
    if (disc > 0) {
      if (!discRow && total) {
        discRow = document.createElement('div');
        discRow.className = 'km-cd-row km-cd-disc';
        discRow.id = 'km-cd-discount-row';
        discRow.innerHTML = '<span>Paket indirimi</span><span id="km-cd-discount"></span>';
        var grand = total.closest('.km-cd-row');
        if (grand && grand.parentElement) grand.parentElement.insertBefore(discRow, grand);
      }
      if (discRow) {
        discRow.style.display = '';
        var dEl = document.getElementById('km-cd-discount');
        if (dEl) dEl.textContent = '-' + fmtMoney(disc, c.currency);
      }
    } else if (discRow) {
      discRow.style.display = 'none';
    }
    if (co) co.style.display = c.item_count > 0 ? '' : 'none';
    if (pchk) pchk.checked = c.items.some(function (it) { return it.variant_id === protVar; });
    if (fsp) {
      if (c.item_count === 0) { fsp.textContent = ''; }
      else if (c.total_price >= freeshipThr * 100) { fsp.textContent = '✓ Tebrikler, kargo bedava!'; fsp.className = 'km-cd-freeship km-ok'; }
      else {
        var kalan = freeshipThr * 100 - c.total_price;
        fsp.textContent = '🚚 ' + fmtMoney(kalan, c.currency) + ' daha ekle, kargo bedava olsun!';
        fsp.className = 'km-cd-freeship';
      }
    }
    var reserve = $('#km-cd-reserve');
    if (reserve) reserve.style.display = c.item_count > 0 ? '' : 'none';
    if (c.item_count > 0) startReserve(); else sessionStorage.removeItem('kmReserveEnd');
    if (!body) return;
    if (!visibleItems.length) {
      body.innerHTML = '<div class="km-cd-empty"><div style="font-size:44px;margin-bottom:10px">\uD83D\uDED2</div><p style="font-weight:600">Sepetiniz boş</p><p style="font-size:14px">Alışverişe başlayın, ürünler burada görünsün.</p></div>';
      return;
    }
    var html = '';
    c.items.forEach(function (it, idx) {
      if (it.variant_id === protVar) return;
      var line = idx + 1;
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_160x$1$2') : '';
      var lineDiscounted = it.final_line_price < it.original_line_price;
      html += '<div class="km-cart-line">'
        + (img ? '<a class="km-cl-img" href="' + it.url + '"><img src="' + img + '" alt="' + esc(it.product_title) + '"></a>' : '<span class="km-cl-img km-cl-noimg"></span>')
        + '<div class="km-cl-info">'
        + '<div class="km-cl-top"><div>'
        + '<div class="km-cl-name"><a href="' + it.url + '">' + esc(it.product_title) + '</a></div>'
        + (it.variant_title ? '<div class="km-cl-variant">' + esc(it.variant_title) + '</div>' : '')
        + '</div>'
        + '<button type="button" class="km-cl-remove" data-cd-change data-line="' + line + '" data-qty="0" aria-label="Kaldır">\uD83D\uDDD1</button>'
        + '</div>'
        + '<div class="km-cl-row">'
        + '<div class="km-qty-ctrl">'
        + '<button type="button" data-cd-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Azalt">−</button>'
        + '<span>' + it.quantity + '</span>'
        + '<button type="button" data-cd-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Artır">+</button>'
        + '</div>'
        + '<span class="km-cl-subtotal">'
        + (lineDiscounted ? '<s class="km-cl-was">' + fmtMoney(it.original_line_price, c.currency) + '</s> ' : '')
        + fmtMoney(it.final_line_price, c.currency) + '</span>'
        + '</div></div></div>';
    });
    body.innerHTML = html;
  }
  function openCartDrawer() {
    if (!cdw) { location.href = '/cart'; return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      renderDrawer(c);
      cdw.classList.add('km-open');
      if (ov) ov.classList.add('km-open');
    }).catch(function () { location.href = '/cart'; });
  }
  var cdc = $('#km-cd-close'); if (cdc) cdc.addEventListener('click', closeAll);
  var cdn = $('#km-cd-continue'); if (cdn) cdn.addEventListener('click', closeAll);
  var cop = $('#km-cart-open');
  if (cop && cdw) cop.addEventListener('click', function (e) { e.preventDefault(); openCartDrawer(); });
  if (cdw) cdw.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-cd-change]');
    if (!b) return;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: parseInt(b.dataset.line, 10), quantity: Math.max(0, parseInt(b.dataset.qty, 10)) }) })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function () {});
  });

  var pchk0 = $('#km-cd-protect-check');
  if (pchk0) pchk0.addEventListener('change', function () {
    if (!protVar) return;
    if (pchk0.checked) {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: protVar, quantity: 1 }] }) })
        .then(function () { return fetch('/cart.js'); }).then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
    } else {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var idx = -1;
        c.items.some(function (it, i) { if (it.variant_id === protVar) { idx = i + 1; return true; } return false; });
        if (idx < 0) { renderDrawer(c); return; }
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: idx, quantity: 0 }) })
          .then(function (r) { return r.json(); }).then(renderDrawer);
      }).catch(function () {});
    }
  });

  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
    var vis = c.items.filter(function (it) { return it.variant_id !== protVar; }).reduce(function (a, it) { return a + it.quantity; }, 0);
    setCartCount(vis);
  }).catch(function () {});

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-km-atc]');
    if (!btn) return;
    ev.preventDefault();
    var id = parseInt(btn.dataset.variantId, 10), qty = parseInt(btn.dataset.qty || '1', 10);
    if (!id) { openCartDrawer(); return; }
    var items = [{ id: id, quantity: qty }];
    var addon = document.querySelector('.km-addon-check');
    if (addon && addon.checked && addon.dataset.variantId) items.push({ id: parseInt(addon.dataset.variantId, 10), quantity: 1 });
    var old = btn.textContent;
    btn.textContent = 'Ekleniyor…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw 0; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        btn.textContent = '✓ Sepete eklendi';
        setTimeout(function () { btn.textContent = old; }, 1800);
        if (btn.dataset.buyNow === 'true') { location.href = '/checkout'; return; }
        renderDrawer(c);
        if (cdw) { cdw.classList.add('km-open'); if (ov) ov.classList.add('km-open'); }
      })
      .catch(function () { btn.textContent = old; openCartDrawer(); });
  });

  var pdp = $('[data-km-pdp]');
  if (pdp) {
    var vEl = $('#km-variant-data');
    var pdpCur = vEl && vEl.dataset.currency ? vEl.dataset.currency : 'TRY';
    function fmtP(cents) { return fmtMoney(cents, pdpCur); }
    var variantData = [];
    try { variantData = JSON.parse(vEl.textContent); } catch (e) {}
    var current = variantData.length ? variantData[0] : null;
    variantData.some(function (v) { if (v.selected) { current = v; return true; } return false; });

    $$('.km-gallery-thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('.km-gallery-main img');
        if (main) { main.src = t.dataset.full || t.src; main.srcset = ''; }
        $$('.km-gallery-thumbs img').forEach(function (x) { x.classList.remove('km-active'); });
        t.classList.add('km-active');
      });
    });

    function activeOpt() { return $('.km-bundle-opt.km-active'); }
    function currentQty() { var a = activeOpt(); return a ? parseInt(a.dataset.qty || '1', 10) : 1; }
    function currentPct() { var a = activeOpt(); return a ? parseFloat(a.dataset.pct || '0') : 0; }

    function syncUI() {
      if (!current) return;
      var q = currentQty(), pct = currentPct();
      var cents = current.cents || 0;
      var total = Math.floor(cents * q * (100 - pct) / 100);
      var price = $('#km-pdp-price'), old = $('#km-pdp-price-old'), disc = $('#km-pdp-discount');
      if (price) price.textContent = (q > 1 || pct > 0) ? fmtP(total) : current.price_f;
      if (old) old.textContent = current.compare_f && q === 1 ? current.compare_f : '';
      if (disc) disc.style.display = (current.compare_f && q === 1) ? '' : 'none';
      $$('[data-km-atc][data-sync]').forEach(function (b) {
        b.dataset.variantId = current.id; b.dataset.qty = q;
      });
      var sbp = $('.km-sb-price'); if (sbp) sbp.textContent = (q > 1 || pct > 0) ? fmtP(total) : current.price_f;
      $$('.km-bundle-opt').forEach(function (o) {
        var oq = parseInt(o.dataset.qty || '1', 10), opct = parseFloat(o.dataset.pct || '0');
        var g = cents * oq;
        var t = Math.floor(g * (100 - opct) / 100);
        var tot = o.querySelector('.km-bundle-total'), sv = o.querySelector('[data-save]'), cmp = o.querySelector('[data-compare]');
        if (tot) tot.textContent = fmtP(t);
        if (sv) sv.textContent = fmtP(g - t);
        if (cmp) {
          var compareCents = current.compare_cents || 0;
          var cmpTotal = compareCents > 0 ? compareCents * oq : g;
          cmp.textContent = fmtP(cmpTotal);
          cmp.style.display = (cmpTotal > t) ? '' : 'none';
        }
      });
    }
    $$('.km-variant-card').forEach(function (o) {
      o.addEventListener('click', function () {
        $$('.km-variant-card').forEach(function (x) { x.classList.remove('km-active'); });
        o.classList.add('km-active');
        var id = parseInt(o.dataset.variantId, 10);
        variantData.some(function (v) { if (v.id === id) { current = v; return true; } return false; });
        if (current && current.image) { var main = $('.km-gallery-main img'); if (main) { main.src = current.image; main.srcset = ''; } }
        try { history.replaceState(null, '', '?variant=' + id); } catch (e) {}
        syncUI();
      });
    });
    $$('.km-bundle-opt').forEach(function (o) {
      o.addEventListener('click', function () {
        $$('.km-bundle-opt').forEach(function (x) { x.classList.remove('km-active'); });
        o.classList.add('km-active');
        syncUI();
      });
    });
    syncUI();

    var sb = $('.km-sticky-bar'), anchor = $('.km-pdp-actions');
    if (sb && anchor) {
      new IntersectionObserver(function (es) {
        sb.classList.toggle('km-visible', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }

    var cd = $('.km-cd-time');
    if (cd) setInterval(function () {
      var now = new Date(), end = new Date(now); end.setHours(23, 59, 59, 999);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(s / 3600)).padStart(2, '0'),
          m = String(Math.floor((s % 3600) / 60)).padStart(2, '0'),
          x = String(s % 60).padStart(2, '0');
      cd.textContent = h + ':' + m + ':' + x;
    }, 1000);
  }

  var fs = $('#km-faq-search');
  if (fs) fs.addEventListener('input', function () {
    var q = fs.value.trim().toLocaleLowerCase('tr');
    var any = false;
    $$('.km-faq-item').forEach(function (it) {
      var hit = !q || it.textContent.toLocaleLowerCase('tr').indexOf(q) !== -1;
      it.style.display = hit ? '' : 'none';
      if (hit) any = true;
    });
    var empty = $('#km-faq-empty'); if (empty) empty.style.display = any ? 'none' : '';
  });

  var minP = $('#km-min-price'), maxP = $('#km-max-price');
  function applyPriceFilter() {
    var lo = parseFloat(minP && minP.value || '') || 0, hi = parseFloat(maxP && maxP.value || '') || Infinity;
    $$('[data-km-price]').forEach(function (card) {
      var p = parseFloat(card.dataset.kmPrice);
      card.style.display = (p >= lo && p <= hi) ? '' : 'none';
    });
  }
  if (minP) minP.addEventListener('input', applyPriceFilter);
  if (maxP) maxP.addEventListener('input', applyPriceFilter);
  var ft = $('#km-mobile-filter-toggle'), fl = $('#km-filters');
  if (ft && fl) ft.addEventListener('click', function () { fl.classList.toggle('km-open'); });

  var ss = $('#km-sort-select');
  if (ss) ss.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', ss.value); location.href = u.toString();
  });

  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var c = e.target, pct = parseFloat(c.dataset.pct || '0'), circ = c.querySelector('.km-ring-prog');
      if (circ) {
        var r = circ.r.baseVal.value, C = 2 * Math.PI * r;
        circ.style.strokeDasharray = C;
        circ.style.strokeDashoffset = C * (1 - pct / 100);
      }
      rio.unobserve(c);
    });
  }, { threshold: 0.4 });
  $$('.km-ring-wrap').forEach(function (el) { rio.observe(el); });
})();
